
import hasPermission from "@/hooks/hasPermission";
export default function Tabs({ activeTab, setActiveTab, setIsItemEdit }) {
  const tabs = [
    { id: "live", label: "Live Table", permission: "table.live_table" },
    { id: "book", label: "Book Table", permission: "table.book_table" },
    { id: "add-edit", label: "Add / Edit Table", permission: "table.add_edit_table" },
    { id: "history", label: "Booking History", permission: "table.table_history" },
  ];

  const visibleTabs = tabs.filter(tab => hasPermission(tab.permission));

  return (
    <div className="flex space-x-8 border-b border-gray-700">
      {visibleTabs.map(tab => (
        <button
          key={tab.id}
          onClick={() => { setActiveTab(tab.id); setIsItemEdit(false) }}
          className={`pb-2 transition-all text-base font-normal ${activeTab === tab.id
            ? "text-yellow-400 border-b-2 border-yellow-400"
            : "text-gray-400 hover:text-white"
            }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
